
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sections/[displayCollectionId]",
      function () {
        return require("private-next-pages/sections/[displayCollectionId].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sections/[displayCollectionId]"])
      });
    }
  